import {FC, useState} from "react";
import {motion} from "framer-motion";
import Chevron from "../Svg/Chevron";
import Text from "../Base/Text";
import IGroup from "../../interfaces/Cookies/IGroup";
import Service from "./Service";

const Group:FC<IGroup> = ({title, description, disabled, name, services, toggle}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [checked, setChecked] = useState(true);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    }

    const countTotalCookies = () => {
        return services.reduce((total, service) => {
            return total + (service.cookies?.length || 0);
        }, 0);
    }

    return <div className="rounded-xl bg-white border-1 border-disabled-300">
        <div className="w-full flex justify-between items-center py-3 px-4 gap-2 font-semibold">
            <button
                className="flex flex-1 items-center gap-2 text-sm cursor-pointer"
                onClick={handleToggle}
            >
                <motion.div
                    animate={{rotate: isOpen ? 180 : 0}}
                    transition={{duration: 0.3}}
                >
                    <Chevron/>
                </motion.div>
                {title}
                {countTotalCookies() > 0 ? <span className="block bg-accent-500 text-white px-1 rounded text-xs">{countTotalCookies()}</span> : null}
            </button>
            <label className="flex-none inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    value=""
                    name={name}
                    className="sr-only peer"
                    checked={checked}
                    onChange={() => {setChecked(!checked); toggle(name)}}
                    disabled={disabled}
                />
                <div className={`checkbox__toggle peer ${disabled ? 'opacity-60 cursor-not-allowed' : ''}`} />
            </label>
        </div>

        <motion.div
            initial={{height: 0, opacity: 0}}
            animate={{height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0}}
            transition={{duration: 0.3}}
            className="overflow-hidden"
        >
            <div className="border-t-1 border-t-disabled-300 pt-3 pb-3">
                { description ? <div className="px-4">
                    <Text as="div"
                          className="text-disabled-500 text-xs mb-2"
                          text={description}
                    />
                </div> : null }

                <div className="flex flex-col gap-1">
                    {
                        services.map((service, index) => {
                            return <Service
                                key={index}
                                name={service.name}
                                url={service.url}
                                description={service.description}
                                cookies={service.cookies}
                            />
                        })
                    }
                </div>
            </div>
        </motion.div>
    </div>
}

export default Group;